import { createColumnHelper } from "@tanstack/table-core";
import { formatCurrency } from "@tillix/utils/format";
import type { ServiceAccountModel } from "../mobx/core/service-account/model.service-account";

export const columnHelper = createColumnHelper<ServiceAccountModel>();

export const ServiceAccountColumns = [
  columnHelper.accessor("externalId", {
    id: "externalId",
    header: "Account #",
  }),
  columnHelper.accessor("nickname", {
    id: "nickname",
    header: "Nickname",
  }),
  columnHelper.accessor("type", {
    id: "type",
    header: "Type",
  }),
  columnHelper.accessor("description", {
    id: "description",
    header: "Description",
  }),
  columnHelper.accessor("balance", {
    id: "balance",
    header: "Balance",
    cell: (info) => formatCurrency(info.getValue()),
  }),
  columnHelper.accessor("tenantId", {
    id: "tenantId",
    header: "Tenant",
  }),
];
